"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/inline-style-prefixer/lib/utils/capitalizeString.js
// module id = 237
// module chunks = 0